import request from '@/service/api'
import ConfigType from '@/service/api/type'
enum dashboardApi {
    DASHBOARDMESSAGE = '/ExamineFlower/MessageReminder',
    DASHBOARDUPDATE = '/ExamineFlower/ReadMessage',
    CHANGEPASSWORD = '/sysUser/updatePwd',
    DeliveryRECEIVE = '/ExamineFlower/DeliveryMessageRemind',//送货单审核消息提醒
    DeliveryRECEIVEREAD = '/ExamineFlower/DeliveryMessageRead',//送货单审核消息读取
    RECEIVE = '/ExamineFlower/CollectNoticeRemind',//收货质检通知提醒
    RECEIVEREAD = '/ExamineFlower/CollectNoticeRead',//收货质检通知读取
    
}
export const getObList = (): ConfigType<any> => {
    return request({
        url: `${dashboardApi.DASHBOARDMESSAGE}`,
    })
}
export const receivelist = (): ConfigType<any> => {
    return request({
        url: `${dashboardApi.RECEIVE}`,
    })
}
export const getUpdate = (data: any): ConfigType<any> => {
    return request({
        url: dashboardApi.DASHBOARDUPDATE,
        method: 'post',
        data: data
    })
}
export const getUpdaterecive = (data: any): ConfigType<any> => {
    return request({
        url: dashboardApi.RECEIVEREAD,
        method: 'post',
        data: data
    })
}
export const getChangePass = (data: any): ConfigType<any> => {
    return request({
        url: dashboardApi.CHANGEPASSWORD,
        method: 'post',
        data: data
    })
}

export const deliveryMessageList = (): ConfigType<any> => {
    return request({
        url: `${dashboardApi.DeliveryRECEIVE}`,
    })
}
export const getUpdateDeliveryMessagee = (data: any): ConfigType<any> => {
    return request({
        url: dashboardApi.DeliveryRECEIVEREAD,
        method: 'post',
        data: data
    })
}

export const getStockWarningMessage = (): ConfigType<any> => {
    return request({
        url: '/ExamineFlower/StockExpireRead',
        method: 'get'
    })
}